import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getPromAccounts, getPromPlatformCategories } from "../api/promApi";
import PromAttributeMappingPanel from "../components/PromAttributeMappingPanel";
import PromTopBar from "../components/marketplace/PromTopBar";
import "./IntegrationsPage.css";

const PromAttributesPage = () => {
    const location = useLocation();
    const [accounts, setAccounts] = useState([]);
    const [accountId, setAccountId] = useState(() => new URLSearchParams(location.search).get("account") || "");
    const [categories, setCategories] = useState([]);
    const [query, setQuery] = useState("23005");
    const [categoryId, setCategoryId] = useState("23005");
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [message, setMessage] = useState("");
    useEffect(() => { getPromAccounts().then((rows) => { setAccounts(rows || []); setAccountId((current) => current || String(rows?.[0]?.id || "")); }).catch(() => setMessage("Не удалось загрузить кабинеты Prom.")); }, []);
    useEffect(() => {
        if (!accountId) return undefined;
        let cancelled = false;
        const timer = setTimeout(async () => {
            try {
                const rows = await getPromPlatformCategories(Number(accountId), { search: query || undefined, limit: 50 });
                if (cancelled) return;
                setCategories(rows || []);
                const current = (rows || []).find((row) => String(row.category_id) === String(categoryId));
                if (current) setSelectedCategory(current);
            } catch (error) {
                if (!cancelled) setMessage(error?.response?.data?.detail || "Не удалось найти категории Prom.");
            }
        }, 180);
        return () => { cancelled = true; clearTimeout(timer); };
    }, [accountId, query, categoryId]);

    return <>
        <PromTopBar activeKey="attributes" accountId={accountId} localKeys={[]} onLocalSelect={() => {}} />
        {message && <div className="ip-status">{message}</div>}

        <section className="ip-card">
            <div className="ip-card-body">
                <h2 className="ip-title">Категория Prom</h2>
                <p className="ip-lead">Импорт схемы категории и mapping характеристик/значений Prom.</p>
                <label className="ip-fld"><span>Найти категорию Prom</span>
                    <input className="ip-inp" placeholder="Введите часть названия или ID: добав, спорт, 23005" value={query} onChange={(e) => setQuery(e.target.value)} />
                    <span className="ip-help-text">Поиск работает по ключевым буквам, а не только по началу слова.</span>
                </label>
                <div className="ip-list" style={{ maxHeight: "230px" }}>
                    {categories.map((row) => (
                        <button
                            key={row.category_id}
                            type="button"
                            className={String(row.category_id) === String(categoryId) ? "ip-list-item sel" : "ip-list-item"}
                            onClick={() => { setCategoryId(row.category_id); setSelectedCategory(row); setQuery(row.category_name_ua); }}
                        >
                            <span className="ip-nm">{row.category_id} · {row.category_name_ua}</span>
                            <span className="ip-meta">{row.category_path_ua || ""}</span>
                        </button>
                    ))}
                    {!categories.length && <span className="ip-lead">Ничего не найдено.</span>}
                </div>
            </div>
        </section>

        <PromAttributeMappingPanel accountId={Number(accountId)} categoryId={categoryId} categoryName={selectedCategory?.category_name_ua || "Категория Prom"} onStatus={setMessage} />
    </>;
};

export default PromAttributesPage;
